import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as types from '../../../constants/index';
import { TeamCalendarWidgetWrapper, WidgetHeader } from './styles';
import CalendarRow from '../../../components/CalendarRow';
import Label from '../../../components/shared/Label';

class TeamCalendarWidgetGazzanet extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  getChildContext = () => ({
    breakpoints: [320, 600, 1024, 1440],
  });


  componentDidMount() {
    window.addEventListener('resize', this.resizeCallback);
    //const interval = ConfigManager.getSportRefreshInterval(this.props.sportId) ? ConfigManager.getSportRefreshInterval(this.props.sportId) : 60000;
    //this.sportTimer = setInterval(this.getTeamCalendar, interval);
    this.getTeamCalendar();
    this.resizeCallback();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
    /* if (this.sportTimer) {
      clearInterval(this.sportTimer);
    }*/
  }

  getTeamCalendar = () => {
    const {
      sportId, teamId, actions, widgetId,
    } = this.props;
    actions.getTeamCalendar(sportId, teamId, true, widgetId);
  };

  getGazzanetDomain = (url) => {
    let returnedDomain = 'gazzetta';
    if (url && url.hostname) {
      const site = url.hostname;
      const [, domain] = site.split('.');
      returnedDomain = domain;
    }
    return returnedDomain;
  };

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 1023,
    });
  };

  isGazzanet = () => {
    let disableLink = false;
    if (process.env.REACT_APP_SITE === 'gazzanet') {
      disableLink = true;
    }
    return disableLink;
  };

  render() {
    const {
      dictionary, calendars, widgetId,
    } = this.props;
    const calendar = calendars.get(widgetId);
    const { isMobile } = this.state;
    return (
      <TeamCalendarWidgetWrapper
        isMobile={isMobile}
      >
        <WidgetHeader className="has-background-primary">
          <Label
            label="Calendario e risultati"
            color="white"
            size={1.2}
            isTitleNarrowMedium
            textAlignment="center"
          />
        </WidgetHeader>
        {calendar && calendar.get('calendar') && calendar.getIn(['calendar', 0]) && calendar.getIn(['calendar', 0, 'matches']) && calendar.getIn(['calendar', 0, 'matches'])
          .map((match, index) => (
            <CalendarRow
              dictionary={dictionary}
              competitionId={match.get('competitionId')}
              isMobile={isMobile}
              matchRow={match}
              key={index}
              newspaper="gazzetta"
              isGazzanet
            />
          ))
        }
      </TeamCalendarWidgetWrapper>
    );
  }
}

TeamCalendarWidgetGazzanet.propTypes = {
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  sportId: PropTypes.any,
  teamId: PropTypes.any,
  calendars: PropTypes.any,
  widgetId: PropTypes.any,
};

export default connect(
  state => ({
    dictionary: state.dictionaryReducer.dictionary,
    calendars: state.calendarReducer.get('calendars'),
  }),
  dispatch => ({
    actions: {
      initDictionary: () =>
        dispatch({ type: types.INIT_DICTIONARY }),
      getTeamCalendar: (sportId, teamId, isWidget, widgetId, seasonId) =>
        dispatch({
          type: types.GET_TEAM_CALENDAR_REQUEST,
          sportId,
          teamId,
          isWidget,
          widgetId,
          seasonId,
        }),
    },
  }),
)(TeamCalendarWidgetGazzanet);



// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/TeamCalendarWidgetGazzanet/index.js